import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import {
  ChakraProvider,
  theme,
  Image,
  Flex,
  Text,
  Link,
  Button,
} from '@chakra-ui/react';
import LandingIcon from '../assets/img/landing.png';
import LogoIcon from '../assets/img/Logo.png';
import WhatsappColorIcon from '../assets/img/whatsapp_color.svg';
import CameraCard from '../components/CameraCard';
import { useHistory } from 'react-router';
import { getEvent } from '../apis/Events';
import { useStoreState } from 'easy-peasy';

const LandingPage = props => {
  const [showLandingPage, SetLandingPage] = useState(false);
  const [event, setEvent] = useState([]);
  const history = useHistory();
  const { id } = props.match.params;
  const isUserLogged = useStoreState(state => state.isUserLogged);
  const invite_friends_text=`Hello, here are your photos from '${event.event_name}'. Please click the link below to view your photos. ${"\n"} 
  https://memzo.ai${process.env.PUBLIC_URL}/photos/${event.event_name_org}/${id}`;
  const inviteUrl  = `https://api.whatsapp.com/send?text=${invite_friends_text}`;
  function fetchEvent() {
    getEvent(id).then(response => {
      !response.error
        ? setEvent(response.data[0])
        : alert(`Error : ${response.message}`);
    });
  }

  // function handleEvent(id){
  //     history.push(`${process.env.PUBLIC_URL}/event/${id}`);
  // }

  useEffect(() => {
    fetchEvent();
  }, []);

  const LandingPageBtn = () => {
    showLandingPage === false ? SetLandingPage(true) : SetLandingPage(false);
  };

  return (
    <React.Fragment>
       <Helmet>
       <title>{event.event_name}</title>
<meta name="description"  content={`${'Your photos from ' + event.event_name}`} />
<meta property="og:title"  content={event.event_name} />
<meta property="og:description" content={`${'Your photos from ' + event.event_name}`} />
<meta property="og:image"  content={event.event_image_url} />
                
            </Helmet>
      <ChakraProvider theme={theme}>
        <Flex
          className="screen-detect-cntr"
          justifyContent="center"
          alignItems="center"
          flexFlow="column"
        >
          <Flex className="screen-detect" flexFlow="column">
            <Flex flexDirection="column">
              <Flex
                justifyContent="space-between"
                borderBottom="1px solid #C4C4C4"
                alignItems="center"
              >
                <Image
                  src={LogoIcon}
                  alt="Logo Icon"
                  objectFit="contain"
                  w="20"
                  ml="4"
                />
                {isUserLogged ? (
                  <Flex>
                    <Link
                      href={`${process.env.PUBLIC_URL + '/events'}`}
                      style={{ textDecoration: 'underline' }}
                    >
                      <Text
                        fontSize="14px"
                        fontWeight="500"
                        pr="2"
                        color="#666666"
                      >
                        My Events
                      </Text>
                    </Link>

                    <Link href={`${process.env.PUBLIC_URL + '/logout'}`}>
                      <Flex alignItems="center" justifyContent="center" mr="2">
                        <Text
                          fontSize="14px"
                          fontWeight="500"
                          color="#FA2F45"
                          textAlign="center"
                        >
                          Logout
                        </Text>
                      </Flex>
                    </Link>
                  </Flex>
                ) : (
                  <Link href={`${process.env.PUBLIC_URL + '/login'}`}>
                    <Flex alignItems="center" justifyContent="center" mr="2">
                      <Text
                        fontSize="14px"
                        fontWeight="500"
                        pr="2"
                        color="#666666"
                      >
                        Existing user?
                      </Text>
                      <Text
                        fontSize="14px"
                        fontWeight="500"
                        color="#FA2F45"
                        textAlign="center"
                      >
                        Log in here
                      </Text>
                    </Flex>
                  </Link>
                )}
              </Flex>
              <Text
                pt="2"
                pb="2"
                fontSize="22px"
                fontWeight="700"
                textAlign="center"
                color="#222222"
              >
                {event.event_name}
              </Text>
              <Image
                fallbackSrc="https://www.freecodecamp.org/news/content/images/2020/05/loading-animation.gif"
                src={event.event_image_url}
                alt="Logo Icon"
                objectFit="contain"
                h="220px"
                pl="3"
                pr="3"
              />
              <Text
                fontSize="18px"
                fontWeight="700"
                mt="4"
                pl="4"
                pr="4"
                textAlign="center"
                color="#222222"
              >
                Find your photos by uploading a selfie{' '}
              </Text>
              <Flex
                className="ps-desktop-div-box"
                style={{ display: 'table-column' }}
              >
                <Text
                  fontSize="16px"
                  fontWeight="600"
                  color="#666666"
                  mt="1"
                  ml="5"
                >
                  See how it works
                </Text>

                <Flex alignItems="center" mt="3">
                  <Text
                    fontSize="13px"
                    fontWeight="700"
                    bg="#ECEFF1"
                    w="8"
                    p="1"
                    textAlign="center"
                    ml="4"
                    borderRadius="20"
                    color="#000000"
                  >
                    1
                  </Text>
                  <Flex alignItems="center" w="100%">
                    <Text
                      pl="4"
                      fontSize="14px"
                      fontWeight="500"
                      color="#666666"
                    >
                      Click a
                    </Text>
                    <Text
                      fontSize="14px"
                      fontWeight="700"
                      color="#666666"
                      pl="1"
                    >
                      selfie
                    </Text>
                  </Flex>
                </Flex>

                <Flex alignItems="center" mt="2">
                  <Text
                    fontSize="13px"
                    fontWeight="700"
                    bg="#ECEFF1"
                    w="7"
                    p="1"
                    textAlign="center"
                    ml="4"
                    borderRadius="20"
                    color="#000000"
                  >
                    2
                  </Text>
                  <Text fontSize="14px" fontWeight="700" color="#666666" pl="4">
                    Find your photos
                  </Text>
                </Flex>

                <Flex alignItems="center" mt="2">
                  <Text
                    fontSize="13px"
                    fontWeight="700"
                    bg="#ECEFF1"
                    w="8"
                    p="1"
                    textAlign="center"
                    ml="4"
                    borderRadius="20"
                    color="#000000"
                  >
                    3
                  </Text>

                  <Flex alignItems="center" w="100%">
                    <Text
                      fontSize="14px"
                      fontWeight="700"
                      color="#666666"
                      pl="4"
                    >
                      Save and Share
                    </Text>
                    <Text
                      fontSize="14px"
                      fontWeight="500"
                      color="#666666"
                      pl="1"
                    >
                      Photos
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
              <Text
                fontSize="14px"
                fontWeight="700"
                color="#666666"
                textAlign="center"
                mt="5"
              >{`${event.total_selfie_scanned} selfies scanned to find ${event.total_photos_found} photos`}</Text>
              <Link
                href={`https://api.whatsapp.com/send?text=${event.invite_friends}`}
              >
                <Flex justifyContent="center" alignItems="center" mt="2">
                  <Text
                    textAlign="center"
                    textDecoration="underline"
                    fontSize="14px"
                    fontWeight="400"
                    color="#FA2F45"
                  >
                    Invite your friends to find their photos
                  </Text>
                  <Image
                    src={WhatsappColorIcon}
                    alt="Logo Icon"
                    objectFit="contain"
                    w="4"
                    ml="2"
                  />
                </Flex>
              </Link>

              <Text
                mb="100px"
                textAlign="center"
                fontSize="12px"
                fontWeight="500"
                pt="4"
                pl="2"
                pr="2"
                color="#999999"
              >
                By continuing, you agree to Memzo’s{' '}
                <Link href="/#" color="#FA2F45">
                  Terms of use
                </Link>{' '}
                and{' '}
                <Link href="/#" color="#FA2F45">
                  Privacy Policy
                </Link>
              </Text>
              <Flex
                className="ps-desktop-width-50-per"
                boxShadow="0px 10px 40px 0px rgb(0 0 0 / 30%)"
                position="fixed"
                bottom="0px"
                alignItems="center"
                justifyContent="center"
                bg="white"
                pt="2"
                pb="2"
                w="100%"
              >
                <Button
                  h="50px"
                  bg="#FA2F45"
                  color="white"
                  fontSize="18px"
                  fontWeight="700"
                  onClick={() => LandingPageBtn(true)}
                >
                  Click Selfie and find my Photos
                </Button>
              </Flex>
            </Flex>

            {showLandingPage && (
              <Flex
                position="fixed"
                top="0"
                className="ps-desktop-width-50-per"
              >
                <CameraCard id={id} {...props} />
              </Flex>
            )}
          </Flex>
        </Flex>
      </ChakraProvider>
    </React.Fragment>
  );
};

export default LandingPage;
